"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listFieldDisplayFormats = void 0;
exports.listFieldDisplayFormats = [
    "colored_pill",
    "text_only",
    "importance",
    "text_icon",
];
